<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >
    <v-select
      v-model="clientCID"
      :items="items"
      :disabled="disabled"
      item-text="label"
      item-value="val"
      class="fm-extern-cid"
      :label="$t('settings.fme.clid.label')">
      <template v-slot:append-outer>
        <cp-help i18n="followme.cid"/>
      </template>
    </v-select>
    <v-text-field class="fm-extern-cid-name"
      v-model="externCIDName" v-show="customCallerIDEnabled" :disabled="disabled" :label="$t('settings.fme.clid.externCIDName')">
      <template v-slot:append-outer>
        <cp-help i18n="followme.externCIDName"/>
      </template>
    </v-text-field>
    <vue-tel-input-vuetify
      v-model="externCIDNum"
      v-show="customCallerIDEnabled"
      class="fm-extern-cid-num"
      :disabled="disabled"
      :label="$t('settings.fme.clid.externCIDNum')"
      :rules="phoneRules"
      placeholder=''
      defaultCountry="CA"
      mode="international">
      <template v-slot:append-outer>
        <cp-help i18n="followme.externCIDNum"/>
      </template>
    </vue-tel-input-vuetify>
  </v-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'settings-followme-clid',
  data () {
    return {
      valid: true
    }
  },
  props: {
    disabled: {
      type: Boolean,
      required: true
    }
  },
  watch: {
    valid (newValue, oldValue) {
      this.$emit('callerid-valid', newValue)
    }
  },
  computed: {
    ...mapGetters({
      fmeData: 'settings/followme'
    }),
    items () {
      return [
        { val: 0, label: this.$t('settings.fme.clid.useUser') },
        { val: 1, label: this.$t('settings.fme.clid.useInbound') },
        { val: 2, label: this.$t('settings.fme.clid.useCustom') }
      ]
    },
    customCallerIDEnabled () {
      return this.clientCID === 2
    },
    phoneRules () {
      return [
        v => (v && /^[0-9 ()\-+]+$/.test(v)) || this.$t('settings.fme.errInvalid')
      ]
    },
    clientCID: {
      get: function () {
        return this.fmeData.externCID
      },
      set: function (val) {
        this.setFollowmeClientCID(val)
      }
    },
    externCIDName: {
      get: function () {
        return this.fmeData.externCIDName
      },
      set: function (val) {
        this.setExternCIDName(val)
      }
    },
    externCIDNum: {
      get: function () {
        return this.fmeData.externCIDNum
      },
      set: function (val) {
        this.setExternCIDNum(val)
      }
    }
  },
  methods: {
    ...mapActions({
      setFollowmeClientCID: 'settings/setFollowmeClientCID',
      setExternCIDName: 'settings/setExternCIDName',
      setExternCIDNum: 'settings/setExternCIDNum'
    })
  }
}
</script>

<style scoped>
</style>
